import { HotkeyBadgeWrapper } from 'pages/Tagging/components/HotkeyBadge/HotkeyBadgeStyles';
import styled from 'styled-components';
import { black, lightgrey, white } from 'styles/Colors';
import { StyledButton } from 'pages/Tagging/components/ScoreBar/StoreTagButton/StoreTagButtonStyles';

export const BpScoreBarOuter = styled.div`
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.08);
  background-color: ${white};
  display: flex;
  align-items: center;
  padding: 0 40px 0 40px;
`;

export const StoreTagButtonAndHotkeyWrapper = styled.div`
  position: relative;
  margin-left: auto;
  ${HotkeyBadgeWrapper} {
    position: absolute;
    z-index: 1;
    top: 2px;
    left: 101px;
  }

  .inning-direction {
    margin-left: -12px;
    margin-right: 13px;
  }

  ${StyledButton} {
    transition: background-color 0.35s ease, border-color 0.35s ease;
  }
`;

export const BpScoreBarWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const ScoreBarDivider = styled.span`
  width: 1px;
  height: 32px;
  opacity: 0.25;
  background-color: ${lightgrey};
  margin-right: 26px;
  margin-left: 26px;
`;

export const TeamName = styled.span`
  font-family: Oswald;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: ${black};

  &.away-team-name {
    margin-right: 13px;
  }
`;
